import React from 'react';
import { Range } from 'rc-slider';
import PropTypes from 'prop-types';
import styles from '../../../search.scss';
import { filterTypes } from '../../../../../utils/constants';

const defaultRangeDisplay = (min, max) => {
    if (min === max) {
        return max.toString();
    }
    return `${min} to ${max}`;
};

const RangeFilter = (props) => {
    const { onChange, rangeKeyMin, rangeKeyMax, defaultValueArr, min, max, title, customRangeDisplay, isHalfSteps, isPickleballRangeFilter, pickleballMoreDesktopFilter, 'data-testid': dataTestId } = props;
    const minVal = min || defaultValueArr[0];
    const maxVal = max || defaultValueArr[1];
    const rangeDisplay = customRangeDisplay ? customRangeDisplay(minVal, maxVal) : defaultRangeDisplay(minVal, maxVal);
    const pickleballRange = 'pickleballRange';

    const marks = {
        1: '1.0',
        2: '2.0',
        3: '3.0',
        4: '4.0',
        5: '5.0',
        6: '6.0',
        7: '7.0',
        8: '8.0',
        9: '9.0',
        10: '10.0',

    };

    const shouldUseMarks = isPickleballRangeFilter || pickleballMoreDesktopFilter === filterTypes.PICKLEBALL_FILTER;

    return (
        <React.Fragment>
            <div className={isPickleballRangeFilter ? styles.searchFilterModalTitleUtrp : styles.searchFilterModalTitle} data-testid={dataTestId && `${dataTestId}.title`}>
                {title} <span className={isPickleballRangeFilter ? styles.utrpRange : styles.utrRange} data-testid={dataTestId && `${dataTestId}.range-display`}>{rangeDisplay}</span>
            </div>
            <div className={`range-wrapper ${shouldUseMarks ? pickleballRange : ''}`} data-testid={dataTestId && `${dataTestId}.slider`}>
                <Range
                    min={rangeKeyMin}
                    max={rangeKeyMax}
                    defaultValue={defaultValueArr}
                    onChange={onChange}
                    step={isHalfSteps ? 0.5 : 1}
                    marks={shouldUseMarks ? marks : {}}
                />
            </div>
        </React.Fragment>
    );
};

RangeFilter.propTypes = {
    onChange: PropTypes.func,
    rangeKeyMin: PropTypes.number.isRequired,
    rangeKeyMax: PropTypes.number.isRequired,
    defaultValueArr: PropTypes.instanceOf(Array).isRequired,
    min: PropTypes.number.isRequired,
    max: PropTypes.number.isRequired,
    title: PropTypes.number.isRequired,
    customRangeDisplay: PropTypes.func,
    isHalfSteps: PropTypes.bool,
    isPickleballRangeFilter: PropTypes.bool,
    pickleballMoreDesktopFilter: PropTypes.string,
    'data-testid': PropTypes.string,
};

RangeFilter.defaultProps = {
    onChange: () => {},
    customRangeDisplay: () => {},
    isHalfSteps: false,
    isPickleballRangeFilter: false,
    pickleballMoreDesktopFilter: '',
    'data-testid': undefined,

};

export default RangeFilter;
